import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCropIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M3 5v4h2V5h4V3H5c-1.105 0-2 .895-2 2Zm2 10H3v4c0 1.105.895 2 2 2h4v-2H5v-4Zm14 4h-4v2h4c1.105 0 2-.895 2-2v-4h-2v4Zm0-16h-4v2h4v4h2V5c0-1.105-.895-2-2-2Z"/>
  </SvgIcon>
}

export default LineCropIcon
